'use client';

export function useBrowserAgent() {

    // const options = {
    //     init: { distributed_tracing: { enabled: true }, privacy: { cookies_enabled: true } },
    //     info: { beacon: "bam.nr-data.net", errorBeacon: "bam.nr-data.net", licenseKey: "NRJS-bf585ac5ce1ff17f05f", applicationID: "1538269971", sa: 1 }, // NREUM.info
    //     loader_config: { accountID: "6624772", trustKey: "6624772", agentID: "1589071247", licenseKey: "NRJS-bf585ac5ce1ff17f05f", applicationID: "1538269971" } // NREUM.loader_config
    // }


    // useEffect(() => {
    //     if (typeof window !== "undefined") {
    //         (async () => {
    //             const { BrowserAgent } = await import(
    //                 "@newrelic/browser-agent/loaders/browser-agent"
    //             );
    //             new BrowserAgent(options);
    //         })()
    //     }
    // }, [options]);

    // useEffect(() => {
    //     const loadHubSpot = () => {
    //         const script = document.createElement('script');
    //         script.src = "//js.hs-scripts.com/48399589.js"; // Your HubSpot script ID
    //         script.async = true;
    //         script.defer = true;
    //         document.body.appendChild(script);
    //     };

    //     // Wait 4 seconds after the page is interactive before loading the script
    //     const timer = setTimeout(loadHubSpot, 6000);

    //     // Clean up the timer if the component unmounts
    //     return () => clearTimeout(timer);
    // }, []);

    return null; // This component renders nothing.
}
